import {mapState} from 'vuex'
import storageUtils from '../../util/storageUtils'
export default {
  props: {
    customType: String,
    customId: String
  },
  computed: {
    ...mapState({
      accountObj: state => state.account
    }),
    wrapperKey () {
      if (this.customId) {
        return `${this.accountObj.loginId || '_anonymous'}$$custom_wrapper_${this.customId}_${this.customType}`
      }
    }
  },
  methods: {
    setWrapper (key, value) {
      if (this.wrapperKey) {
        storageUtils.setItem(this.wrapperKey, key, value)
      }
    },
    getWrapper (key) {
      if (this.wrapperKey) {
        return storageUtils.getItem(this.wrapperKey, key)
      }
    }
  }
}
